import { render, staticRenderFns } from "./InvestigatorDetailUpload.vue?vue&type=template&id=45b47885&"
import script from "./InvestigatorDetailUpload.vue?vue&type=script&lang=js&"
export * from "./InvestigatorDetailUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports